export default "__VITE_ASSET__ppgxWhR7__"